import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import './OldDarkPage.css';
import airplane from './assets/airplane.png';
import radial from './assets/background-dark.png';

const translations = {
  en: {
    connectionMessage: "The connection between the account and the program is established"
  }
};

const OldDarkPage = () => {
  const location = useLocation();
  const { inputText = '' } = location.state || {};
  const [connectionMessage, setConnectionMessage] = useState(false);
  const [multiplier, setMultiplier] = useState('1.00x');

  const host_server = '/get_multiplier';

  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setConnectionMessage(true);
    const messageTimeout = setTimeout(() => setConnectionMessage(false), 2000);

    const updateMultiplier = async () => {
      try {
        const response = await axios.get(host_server);
        const newMultiplier = response.data.result + 'x';
        setMultiplier(newMultiplier);
      } catch (error) {
        console.error('There was an error fetching the multiplier:', error);
      }
    };

    updateMultiplier();
    const intervalId = setInterval(updateMultiplier, 3000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(messageTimeout);
    };
  }, []);

  return (
    <div className="game-container-old" style={{ backgroundImage: `url(${radial})` }}>
      <img src={airplane} alt="Airplane" className="game-airplane-logo" />
      <div className={`circles ${animate ? 'animate' : ''}`}>
        <div className="circle circle-1">
          <div className="dot"></div>
        </div>
        <div className="circle circle-2">
          <div className="dot"></div>
        </div>
        <div className="circle circle-3">
          <div className="dot"></div>
        </div>
        <div className="multiplier-old">{multiplier}</div>
      </div>
      {connectionMessage && (
        <div className={`connection-message-old ${connectionMessage ? 'visible' : ''}`}>
          {translations.en.connectionMessage}
        </div>
      )}
      <div className="input-text-display-old">{inputText}</div>
    </div>
  );
};

export default OldDarkPage;
